import React from 'react';
import {PencilSquareIcon, CheckIcon} from '@heroicons/react/20/solid';
import {Menu, Transition} from '@headlessui/react';
import {
  useCurrentClientQuery,
  useAccountPoolQuery,
  useUpdateAccountPoolClientAccountStatusMutation,
} from 'api';
import {useParams} from 'react-router-dom';

const StatusSelect = () => {
  const {data: {currentClient: {accountStatuses = []} = {}} = {}} =
    useCurrentClientQuery({});
  const {accountId} = useParams<{
    accountId: string;
  }>();
  const [updateClientAccountStatus] =
    useUpdateAccountPoolClientAccountStatusMutation({});

  const {data: {accountPool = {}} = {}} = useAccountPoolQuery({
    variables: {uuid: accountId},
    skip: !accountId,
  });
  const selectedStatus = accountPool?.clientAccountStatus;

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-c-light">企業ステータス</div>
          <span
            className={`px-3 py-1 rounded-full text-xs leading-none font-bold tracking-tight ${selectedStatus && 'bg-[#DCEEFF]'} text-[#005388]`}>
            {selectedStatus?.name}
          </span>
        </div>
        <Menu.Button className="cursor-pointer bg-transparent border-none outline-none flex items-center">
          <PencilSquareIcon className="w-5 h-5 text-c-primary" />
        </Menu.Button>
      </div>
      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95">
        <Menu.Items className="absolute origin-top-right rounded bg-white shadow z-10 w-[calc(100%-3rem)] right-12">
          {accountStatuses.map((status) => (
            <Menu.Item key={status.id}>
              {({active}) => (
                <div
                  onClick={() =>
                    updateClientAccountStatus({
                      variables: {
                        id: accountPool?.id,
                        clientAccountStatusId: status.id,
                      },
                    })
                  }
                  className={`${
                    active ? 'bg-c-bg' : ''
                  } w-full flex items-center gap-2 py-1 px-2 cursor-pointer`}>
                  <CheckIcon
                    className={`w-4 h-4 ${status.id === selectedStatus?.id ? 'text-c-primary' : 'text-transparent'}`}
                  />
                  <div className="flex flex-col">
                    <h4 className="text-sm font-normal m-0">{status.name}</h4>
                    <p className="m-0 p-0 text-xs text-c-light">
                      {status.description}
                    </p>
                  </div>
                </div>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default StatusSelect;
